
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_c2y4y_26",
  "button": "awsui_button_vjswe_c2y4y_30",
  "variant-normal": "awsui_variant-normal_vjswe_c2y4y_82",
  "disabled": "awsui_disabled_vjswe_c2y4y_100",
  "variant-primary": "awsui_variant-primary_vjswe_c2y4y_107",
  "variant-link": "awsui_variant-link_vjswe_c2y4y_132",
  "variant-icon": "awsui_variant-icon_vjswe_c2y4y_157",
  "variant-control-group-action": "awsui_variant-control-group-action_vjswe_c2y4y_182",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_c2y4y_209",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_c2y4y_234",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_c2y4y_259",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_c2y4y_288",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_c2y4y_313",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_c2y4y_338",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_c2y4y_368",
  "button-no-text": "awsui_button-no-text_vjswe_c2y4y_481",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_c2y4y_485",
  "full-width": "awsui_full-width_vjswe_c2y4y_488",
  "button-compact": "awsui_button-compact_vjswe_c2y4y_505",
  "icon-left": "awsui_icon-left_vjswe_c2y4y_535",
  "icon-right": "awsui_icon-right_vjswe_c2y4y_540",
  "icon": "awsui_icon_vjswe_c2y4y_535",
  "link": "awsui_link_vjswe_c2y4y_559",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_c2y4y_559"
};
  